import { apiRequest } from '@/services/http'

/** `bs-talent.users`, minus `firebaseUid` — the shape `talent-service`'s `GET /v1/me` returns. */
export interface TalentAccount {
  _id: string
  slug: string
  email: string
  name: { first?: string; last?: string; firstLocalized?: string; lastLocalized?: string }
  title?: string
  phone?: string
  phoneCountryCode?: string
  /** Twilio Verify approved the number (legacy `phoneVerified` claim). */
  phoneVerifiedAt?: string
  birthDate?: string
  gender: number
  govId?: string
  securityClearance: boolean
  company?: { id?: string; name?: string }
  location?: { cityId?: number; country?: string }
  profileId?: string
  avatarFileId?: string
  /** Derived server-side (public bucket, `profile-images/`) — absent when there's no avatar. */
  avatarUrl?: string
  notifications: { jobUpdates?: { email: boolean }; companyUpdates?: { email: boolean } }
  visibility: number
  state: { isActivated: boolean; isClosed: boolean; isDeleted: boolean }
}

export interface UpdateTalentAccountInput {
  name?: { first?: string; last?: string }
  title?: string
  birthDate?: string
  govId?: string
  securityClearance?: boolean
  gender?: number
  phone?: string
  phoneCountryCode?: string
  email?: string
  notifications?: { jobUpdates?: { email: boolean }; companyUpdates?: { email: boolean } }
  visibility?: number
  accountClosed?: true
  location?: { cityId: number; country: string }
}

export function getMyAccount(): Promise<{ user: TalentAccount }> {
  return apiRequest('/v1/me')
}

export function updateMyAccount(input: UpdateTalentAccountInput): Promise<{ user: TalentAccount }> {
  return apiRequest('/v1/me', { method: 'PATCH', body: JSON.stringify(input) })
}

/** Legacy talent-api sendVerificationCode / checkVerificationCode (Twilio Verify, SMS). */
export function startPhoneVerification(phone: string): Promise<{ to: string; status: string }> {
  return apiRequest('/v1/me/phone-verification/start', { method: 'POST', body: JSON.stringify({ phone }) })
}

export function checkPhoneVerification(phone: string, code: string): Promise<{ status: 'verified' | 'not-verified'; message: string }> {
  return apiRequest('/v1/me/phone-verification/check', { method: 'POST', body: JSON.stringify({ phone, code }) })
}
